import React, { useState } from 'react';
import { Link } from "react-router-dom";
import { Accordion, Button, Card, Container, Form, FormControl, FormLabel, Modal } from 'react-bootstrap';
import "bootstrap/dist/css/bootstrap.min.css";
import "../general.css";
import "./answer.css";
import pass from "./password.json";
import { useCookies } from "react-cookie";

const Answer = ({ en }) => {
    const [show, setShow] = useState(false);
    const [show2, setShow2] = useState(false);
    const [msg, setMsg] = useState("");
    const [input, setInput] = useState("");
    const [cookies, setCookie, removeCookie] = useCookies();

    const handleSubmit = () => {
        // const katakanaRegex = /[\u30A1-\u30FA]/g;
        const passward = input.toLowerCase()//.replace(katakanaRegex, x => String.fromCharCode(x.charCodeAt(0) - 0x60));
        if (pass[passward] !== undefined) {
            const key = pass[passward];
            setCookie(key, true, { maxAge: 2592000 });
            if (en) {
                setMsg((key[0] === "b" ? "Blue" : "Red") + " #" + key[1] + " is now open!")
            } else {
                setMsg((key[0] === "b" ? "青色" : "赤色") + "の" + key[1] + "番が開放されました！")
            }
        } else {
            if (en) {
                setMsg("WRONG PASSWORD")
            } else {
                setMsg("パスワードが違います")
            }
        }
        setShow(false);
        setShow2(true);

        // setCookie(key, true, { maxAge: 2592000 });
    }

    return (
        <>
            <div className='answer_button' style={{ backgroundImage: "url('/img/key.png')" }} onClick={() => setShow(true)}></div>
            <Modal show={show} size='lg' onHide={() => setShow(false)} className='text-dark'>
                <Modal.Header closeButton>
                    {en ? "PASSWORD" : "パスワード"}
                </Modal.Header>
                <Modal.Body className='m-4'>
                    {/* <Form className='text-start'> */}
                    <FormControl type='text' autoFocus value={input} onChange={(e) => setInput(e.target.value)} />
                    {/* </Form> */}
                    <div className='d-grid mt-3'>
                        <Button variant='success' type='submit' onClick={() => handleSubmit()}>{en ? "SUBMIT" : "決定"}</Button>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal show={show2} size='lg' onHide={() => setShow2(false)} className='text-dark'>
                <Modal.Body className='m-4'>
                    {msg}
                    <div className='d-grid mt-3'>
                        <Button variant='success' type='submit' onClick={() => setShow2(false)}>OK</Button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default Answer;
